const JP = {
  leadLines: ["撮りたい写真を選ぶだけ。宮古島旅行日程を作成します。"],
  optionSectionTitle: "追加したい体験を選択",
  selectedLabel: "追加中",
  peopleLabel: "人数",
  peopleUnit: "名",
  topNote: "※ 写真を選ぶと、スケジュールが自動で変わります。",
  noExtraFee: "追加料金なし",
  selectedBaseLabel: "選択済み",
  unselectedBaseLabel: "未選択",
  baseTourTitle: "秘境フォトツアー",
  baseTourText:
    "約3時間、秘境スポットや絶景撮影スポットを巡りながら撮影します。",
  preparingLabel: "準備中",
  perPerson: "人",
  perGroup: "グループ",
  pricePerPersonTotal: "1名あたり合計料金",
  totalSuffix: "合計",
  basePrice: "基本料金",
  optionPrice: "オプション",
  extraPeoplePrice: "追加人数",
  extraPeopleNote: "5名様以上は1名追加ごとに +¥20,000",
  scheduleTitle: "おすすめスケジュール",
  scheduleNoticeLines: [
    "※ スケジュールはお客様のご要望に合わせて変更可能です。",
    "複数日に分けてゆっくりご案内する前提でご提案します。",
    "また、天候や海況により変動する場合がございますのでご了承ください。",
  ],
  handwriting: "Have a wonderful day in Miyako island",
  priceJoiner: " ＋ ",
  decreasePeopleLabel: "人数を減らす",
  increasePeopleLabel: "人数を増やす",
};

const EN = {
  leadLines: [
    "Choose the photos you want, and we will suggest the right tour plan.",
    "We split the experiences across your stay instead of packing everything into one day.",
  ],
  optionSectionTitle: "Choose Your Add-On Experiences",
  selectedLabel: "Selected",
  peopleLabel: "Guests",
  peopleUnit: "guests",
  peopleSingular: "guest",
  peoplePlural: "guests",
  topNote:
    "※ Select photo styles to update the plan, price, and recommended itinerary.",
  noExtraFee: "No extra charge",
  selectedBaseLabel: "Selected",
  unselectedBaseLabel: "Not selected",
  baseTourTitle: "Scenic Tour",
  baseTourText:
    "Scenic spots, drone shooting, and mirrorless camera photography included",
  preparingLabel: "Coming soon",
  perPerson: "person",
  perGroup: "group",
  pricePerPersonTotal: "Total per person",
  totalSuffix: "total",
  basePrice: "Base price",
  optionPrice: "Options",
  extraPeoplePrice: "Additional guests",
  extraPeopleNote: "+¥20,000 per additional guest for groups of 5 or more",
  scheduleTitle: "Recommended Schedule",
  scheduleNoticeLines: [
    "※ The schedule can be adjusted based on your preferences.",
    "The plan is designed to be split across multiple days when possible.",
    "Please note that the schedule may change depending on weather and sea conditions.",
  ],
  handwriting: "Have a wonderful day in Miyako island",
  priceJoiner: " + ",
  decreasePeopleLabel: "Decrease guests",
  increasePeopleLabel: "Increase guests",
};

const 中文 = {
  leadLines: [
    "只需选择想拍的照片类型，我们会推荐适合的体验行程。",
    "不会把所有体验塞进同一天，会根据住宿天数分开安排。",
  ],
  optionSectionTitle: "选择想追加的体验",
  selectedLabel: "已追加",
  peopleLabel: "人数",
  peopleUnit: "人",
  topNote: "※ 选择照片类型后，推荐行程、价格和日程会自动变化。",
  noExtraFee: "无需追加费用",
  selectedBaseLabel: "已选择",
  unselectedBaseLabel: "未选择",
  baseTourTitle: "绝景行程",
  baseTourText: "包含绝景景点巡游、无人机拍摄和相机拍摄",
  preparingLabel: "准备中",
  perPerson: "人",
  perGroup: "组",
  pricePerPersonTotal: "每人合计价格",
  totalSuffix: "合计",
  basePrice: "基础费用",
  optionPrice: "选项",
  extraPeoplePrice: "追加人数",
  extraPeopleNote: "5人以上每增加1人 +¥20,000",
  scheduleTitle: "推荐行程",
  scheduleNoticeLines: [
    "※ 行程可根据客人的需求进行调整。",
    "会尽量分成多天轻松安排。",
    "请注意，行程可能会因天气和海况而变动。",
  ],
  handwriting: "Have a wonderful day in Miyako island",
  priceJoiner: " ＋ ",
  decreasePeopleLabel: "减少人数",
  increasePeopleLabel: "增加人数",
};

const 한국어 = {
  leadLines: [
    "남기고 싶은 사진을 선택하면 어울리는 체험 플랜을 제안합니다.",
    "하루에 모두 넣지 않고 숙박 일정에 맞춰 여유롭게 나눠드립니다.",
  ],
  optionSectionTitle: "추가하고 싶은 체험 선택",
  selectedLabel: "추가 중",
  peopleLabel: "인원",
  peopleUnit: "명",
  topNote:
    "※ 사진 스타일을 선택하면 플랜, 요금, 추천 일정이 자동으로 바뀝니다.",
  noExtraFee: "추가 요금 없음",
  selectedBaseLabel: "선택됨",
  unselectedBaseLabel: "미선택",
  baseTourTitle: "절경 투어",
  baseTourText: "절경 스팟 투어, 드론 촬영, 카메라 촬영 포함",
  preparingLabel: "준비 중",
  perPerson: "명",
  perGroup: "그룹",
  pricePerPersonTotal: "1인당 총 요금",
  totalSuffix: " 합계",
  basePrice: "기본 요금",
  optionPrice: "옵션",
  extraPeoplePrice: "추가 인원",
  extraPeopleNote: "5명 이상은 1명 추가 시 +¥20,000",
  scheduleTitle: "추천 일정",
  scheduleNoticeLines: [
    "※ 일정은 고객님의 요청에 맞게 변경 가능합니다.",
    "가능하면 여러 날로 나누어 여유롭게 안내하는 구성입니다.",
    "또한 날씨와 해양 상황에 따라 변동될 수 있으니 양해 부탁드립니다.",
  ],
  handwriting: "Have a wonderful day in Miyako island",
  priceJoiner: " ＋ ",
  decreasePeopleLabel: "인원 줄이기",
  increasePeopleLabel: "인원 늘리기",
};

export const customizeText = {
  JP,
  EN,
  中文,
  한국어,
};
